import { createTheme } from '@material-ui/core/styles';

export const PeBatteryTheme = createTheme({
    typography: {
        fontFamily: 'Roboto, sans-serif',
        fontSize: 16,
    },
    palette: {
        primary: {
            light: '#B3B3B3',
            main: '#403F40', //7E4085
            dark: '#000000',
        },
        secondary: {
            light: '#F1F1F2',
            main: '#D3D3D3',
            dark: '#9F9F9F',
        },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': 'Roboto',
            },
        },
        MuiTooltip: {
            tooltip: {
                fontSize: '14px',
                color: '#717171',
                backgroundColor: 'white',
                border: '1px solid #717171',
                borderRadius: '5px',
            },
        },
        MuiAccordion: {
            root: {
                boxShadow: 'none',
                border: '1px solid #F1F1F2',
                '&$expanded': {
                    border: '1px solid #F1F1F2',
                    borderRadius: '5px',
                },
                '&$disabled': {
                    backgroundColor: '#F1F1F2',
                },
                '&::before': {
                    height: 0,
                },
            },
        },
        MuiTypography: {
            root: {
                fontWeight: 'bold',
            },
            body1: {
                fontWeight: 'bold',
            }
        },
        MuiAccordionSummary: {
            root: {
                padding: '0 10px',
                '&$expanded': {
                    minHeight: '45px',
                    borderBottom: '1px solid #F1F1F2',
                },
            },
            content: {
                '&$expanded': {
                    margin: '10px 0',
                },
            },
        },
        MuiAccordionDetails: {
            root: {
                padding: '8px',
            },
        },
        MuiList: {
            root: {
                width: '100%',
            },
        },
        MuiFormControlLabel: {
            label: {
                fontSize: 'inherit',
                color: 'inherit',
            },
        },
        MuiCardActions: {
            root: {
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyItems: 'center',
                justifyContent: 'center',
            },
        },
        MuiTableRow: {
            root: {},
        },
        MuiTableCell: {
            root: {
                fontFamily: 'inherit',
                fontSize: 'inherit',
                borderBottom: 'none',
                padding: '12px',
            },
            head: {
                fontWeight: 'bold',
                backgroundColor: '#D3D3D3',
            },
            body: {
                color: 'inherit',
            },
        },
        MuiInputBase: {
            root: {
                fontSize: 'inherit',
            },
        },
        MuiButton: {
            root: {
                textTransform: 'none',
            },
        },
        MuiFormHelperText: {
            contained: {
                marginLeft: '0px',
                marginRight: '0px',
            },
        },
    },
});
